import { observer } from "mobx-react-lite";
import React from "react";
import { Button, Flex } from "antd";
import { t } from "i18next";
import { EntityCardStore } from "src/pages/EntityCardPage/EntityCardStore";
import styles from "./EntityConfirmHeader.module.less";

interface PropsEntityConfirmHeader {
  store: EntityCardStore;
}

export const EntityConfirmHeader: React.FC<PropsEntityConfirmHeader> = observer(
  ({ store }) => (
    <div className={styles.header}>
      <Flex align="center" gap={8} className={styles.content}>
        <div className={styles.text}>
          {t("The form contains unsaved data. Continue with data loss?")}
        </div>
        <Button
          className={styles.cancelButton}
          onClick={() => store.setOnConfirm(null)}
        >
          {t("Cancel")}
        </Button>
        <Button type="primary" onClick={() => store.confirmClosure()}>
          {t("Continue")}
        </Button>
      </Flex>
    </div>
  ),
);
